import { Typography } from '@euler/app/components/typography';
import { BottomPanel } from '@euler/components/BottomPanel';
import { kApdmSendingPolicyLabels } from '@euler/functions/apdm/campaignLabels';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ApdmSendingPolicy } from '@euler/model/apdm';
import { Check } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';
import { aiColors, tint } from '../theme';

/**
 * Where a campaign reaches its customers, picked from a sheet: every
 * policy, the one a campaign takes when none is picked marked 默认.
 */
export const SendingPolicyPanel = memo(
  ({
    visible,
    value,
    defaultPolicy,
    onClose,
    onSelect,
  }: {
    visible: boolean;
    value: ApdmSendingPolicy;
    defaultPolicy: ApdmSendingPolicy;
    onClose: () => void;
    onSelect: (policy: ApdmSendingPolicy) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <BottomPanel visible={visible} onClose={onClose} fitContent>
        <View style={{ padding: rpx(20), gap: rpx(4) }}>
          <Typography.Text
            medium
            size={rpx(13)}
            color={aiColors.mutedForeground}
          >
            发送方式
          </Typography.Text>
          {Object.values(ApdmSendingPolicy).map(policy => {
            const selected = policy === value;
            return (
              <Pressable
                key={policy}
                accessibilityRole="radio"
                accessibilityState={{ checked: selected }}
                onPress={() => onSelect(policy)}
                style={({ pressed }) => ({
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: rpx(8),
                  paddingVertical: rpx(14),
                  opacity: pressed ? 0.6 : 1,
                })}
              >
                <Typography.Text
                  size={rpx(15)}
                  color={selected ? aiColors.primary : aiColors.foreground}
                  style={{ flexShrink: 1 }}
                >
                  {kApdmSendingPolicyLabels[policy]}
                </Typography.Text>
                {policy === defaultPolicy ? (
                  <View
                    style={{
                      paddingHorizontal: rpx(6),
                      paddingVertical: rpx(1),
                      borderRadius: rpx(4),
                      backgroundColor: tint(aiColors.primary, 0.12),
                    }}
                  >
                    <Typography.Text size={rpx(11)} color={aiColors.primary}>
                      默认
                    </Typography.Text>
                  </View>
                ) : null}
                <View style={{ flex: 1 }} />
                {selected ? (
                  <Check size={rpx(18)} color={aiColors.primary} />
                ) : null}
              </Pressable>
            );
          })}
        </View>
      </BottomPanel>
    );
  },
);
